"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/link/index.ts
var link_exports = {};
__export(link_exports, {
  default: () => Link_default
});
module.exports = __toCommonJS(link_exports);
var import_index = require("./index.css");

// src/link/Link.tsx
var import_classnames = __toESM(require("classnames"));

// src/link/link.module.scss
var link_module_default = {
  "heading-xxl": "link-module__heading-xxl___NWhiO",
  "heading-xl": "link-module__heading-xl___reHWW",
  "heading-lg": "link-module__heading-lg___vrkyU",
  "heading-md": "link-module__heading-md___DgXip",
  "heading-sm": "link-module__heading-sm___p4wYS",
  "heading-xs": "link-module__heading-xs___4dzMP",
  "body-one": "link-module__body-one___9dMa8",
  "body-two": "link-module__body-two___A55Jq",
  "body-three": "link-module__body-three___U22yO",
  "body-four": "link-module__body-four___jLkaW",
  "overline-one": "link-module__overline-one___ujSBW",
  "overline-two": "link-module__overline-two___8OvVA",
  "overline-three": "link-module__overline-three___800o1",
  "strong": "link-module__strong___GfpHM",
  "extra-strong": "link-module__extra-strong___Tf0eY",
  "em": "link-module__em___ihSMB",
  "figcaption": "link-module__figcaption___hOiiQ",
  "link": "link-module__link___nBh09",
  "link-primary": "link-module__link-primary___Cgm-i",
  "link-secondary": "link-module__link-secondary___xHFLi",
  "link-l": "link-module__link-l___3mskp",
  "link-m": "link-module__link-m___aQawz",
  "link-s": "link-module__link-s___zlJ-K",
  "link-xs": "link-module__link-xs___Pg8mp"
};

// src/link/Link.tsx
var import_jsx_runtime = require("react/jsx-runtime");
var Link = ({
  children,
  text,
  id,
  className,
  external,
  openInNewTab,
  href = "#",
  disabled,
  onClick,
  size = "m",
  type = "primary",
  role,
  ...HTMLAttributes
}) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
  "a",
  {
    className: (0, import_classnames.default)(
      link_module_default.link,
      link_module_default[`link-${type}`],
      link_module_default[`link-${size}`],
      className
    ),
    href: !disabled ? href : void 0,
    id,
    onClick: !disabled ? onClick : void 0,
    rel: openInNewTab || external ? "noopener noreferrer" : void 0,
    target: (openInNewTab || void 0) && "_blank",
    role,
    ...disabled ? { "aria-disabled": true } : {},
    ...HTMLAttributes,
    children: text || children
  }
);
var Link_default = Link;
//# sourceMappingURL=index.js.map